<template>
  <div class="modal-overlay planning" >
    <div class="modal-content">
      <div class="modal-header">
        <h3>Lieu de l'entretien</h3>
      </div>

      <div class="modal-body">
        <div v-if="!options.length" class="text-center">
          Aucun établissement disponible
        </div>

        <ul v-else class="choice-list">
          <li v-for="(item, index) in options" :key="index" class="choice-item">
            <span class="of-name">{{ item.ofName }}</span>
            <em class="opacity-70" style="font-size:12px; padding-top: 8px">{{ item.campusAddress }}</em>
            <em class="opacity-70" style="font-size:12px; padding-bottom: 10px ">{{ item.campusPostalCode }} {{ item.campusCityName }}</em>

            <button
                class="btn btn-primary"
                @click="select(item.url)"
            >
              Accéder
            </button>
          </li>
        </ul>


      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  options: {type: Array, required: true}
})

const emit = defineEmits(['select'])



const select = (url) => {
  emit('select', url)
}
</script>

<style scoped>
.choice-list {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
}

.choice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}

.of-name {
  font-weight: 500;
}
</style>
